import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { fetchGuestById, fetchGuestOrders } from '../store/slices/guestSlice';

const GuestProfilePage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const dispatch = useAppDispatch();
  const { currentGuest, guestOrders } = useAppSelector((s) => s.guest);

  useEffect(() => {
    if (id) {
      dispatch(fetchGuestById(Number(id)));
      dispatch(fetchGuestOrders(Number(id)));
    }
  }, [dispatch, id]);

  if (!currentGuest) return <div className="page-shell" style={{ maxWidth: '800px' }}>Завантаження...</div>;

  return (
    <div className="page-shell guest-profile-page" style={{ maxWidth: '800px' }}>
      <h2 style={{ color: 'var(--crm-text)', borderBottom: '2px solid var(--crm-accent)', paddingBottom: '8px' }}>Профіль гостя</h2>
      <div className="guest-profile-summary" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginTop: '20px' }}>
        <div
          style={{
            background: 'var(--crm-surface)',
            border: '1px solid var(--crm-border)',
            padding: '20px',
            borderRadius: 'var(--crm-radius-md)',
            boxShadow: 'var(--crm-shadow-sm)',
          }}
        >
          <h3 style={{ color: 'var(--crm-text)', marginTop: 0 }}>Особиста інформація</h3>
          <p>
            <strong>Ім'я:</strong> {currentGuest.name}
          </p>
          <p>
            <strong>Телефон:</strong> {currentGuest.phone}
          </p>
          <p>
            <strong>Email:</strong> {currentGuest.email}
          </p>
          <p>
            <strong>Зареєстрований:</strong> {new Date(currentGuest.registeredAt).toLocaleDateString('uk-UA')}
          </p>
        </div>
        <div
          style={{
            background: 'var(--crm-surface)',
            border: '1px solid var(--crm-border)',
            padding: '20px',
            borderRadius: 'var(--crm-radius-md)',
            boxShadow: 'var(--crm-shadow-sm)',
          }}
        >
          <h3 style={{ color: 'var(--crm-text)', marginTop: 0 }}>Персональна знижка</h3>
          <p>
            <strong>Тип знижки:</strong> {currentGuest.discountType === 'None' ? 'Немає' : currentGuest.discountType}
          </p>
          {currentGuest.discountType !== 'None' && (
            <>
              <p>
                <strong>Розмір:</strong> {currentGuest.discountValue}
                {currentGuest.discountType === 'Percent' ? '%' : ' ₴'}
              </p>
              <p>
                <strong>Активна:</strong>{' '}
                <span style={{ color: currentGuest.isDiscountActive ? 'var(--crm-success)' : 'var(--crm-danger)' }}>
                  {currentGuest.isDiscountActive ? 'Так' : 'Ні'}
                </span>
              </p>
            </>
          )}
        </div>
      </div>

      <h3 style={{ color: 'var(--crm-text)', marginTop: '32px' }}>Історія замовлень ({guestOrders.length})</h3>
      {guestOrders.length === 0 ? (
        <p style={{ color: 'var(--crm-text-muted)' }}>Замовлень немає</p>
      ) : (
        <table
          className="crm-table"
          style={{
            width: '100%',
            borderCollapse: 'collapse',
            background: 'var(--crm-surface)',
            borderRadius: 'var(--crm-radius-md)',
            overflow: 'hidden',
            boxShadow: 'var(--crm-shadow-sm)',
          }}
        >
          <thead style={{ background: 'var(--crm-navbar-dropdown-bg)', color: 'var(--crm-primary-contrast)' }}>
            <tr>
              <th style={{ padding: '10px 12px', textAlign: 'left' }}>№</th>
              <th style={{ padding: '10px 12px', textAlign: 'left' }}>Статус</th>
              <th style={{ padding: '10px 12px', textAlign: 'left' }}>Дата</th>
              <th style={{ padding: '10px 12px', textAlign: 'left' }}>Сума</th>
              <th style={{ padding: '10px 12px', textAlign: 'left' }}>Знижка</th>
              <th style={{ padding: '10px 12px', textAlign: 'left' }}>Фінальна сума</th>
            </tr>
          </thead>
          <tbody>
            {guestOrders.map((o, i) => (
              <tr key={o.id} style={{ background: i % 2 === 0 ? 'var(--crm-surface-alt)' : 'var(--crm-surface)' }}>
                <td style={{ padding: '10px 12px' }}>#{o.id}</td>
                <td style={{ padding: '10px 12px' }}>{o.status}</td>
                <td style={{ padding: '10px 12px' }}>{new Date(o.createdAt).toLocaleDateString('uk-UA')}</td>
                <td style={{ padding: '10px 12px' }}>{o.totalPrice.toFixed(2)} ₴</td>
                <td style={{ padding: '10px 12px', color: 'var(--crm-danger)' }}>-{o.appliedDiscountValue.toFixed(2)} ₴</td>
                <td style={{ padding: '10px 12px', fontWeight: 'bold', color: 'var(--crm-success)' }}>{o.finalPrice.toFixed(2)} ₴</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default GuestProfilePage;
